// extracted by mini-css-extract-plugin
export default {"statsContainer":"Kx6fhT0FdMer1gU6pFR6"};